//import axios from "axios";
import ApiService from "@/core/services/api.service";
// action types
export const OBTENER_BOLETAS = "obtenerBoletas";
export const OBTENER_BOLETA = "obtenerBoleta";
export const REGISTRAR_BOLETA = "registrarBoleta";
export const ACTUALIZAR_BOLETA = "actualizarBoleta";



// mutation types
export const SET_BOLETAS = "setBoletas";
export const SET_BOLETA = "setBoleta";

const state = {
    boletas:[],
    boleta:[],    
}

const getters = {
    obtenerBoletas(state) {
      return state.boletas;
    },
}

const actions = {


    /**
     * Obtener las boletas
     * @param {*} context 
     * @param {*} estadoId 
     * @returns 
     */
    async [OBTENER_BOLETAS](context, datos) {
        
        let endpoint = `api/Boleta`;
        if(datos.estadoId>0){
            endpoint = `api/Boleta/Estado/${estadoId}`
        }

        if(datos.idPeriodo > 0){
            endpoint = `api/Boleta/all/${datos.idPeriodo}/${datos.idIndice}`;
        }
       // console.log(endpoint)
        return new Promise(resolve => {
            ApiService.query(`apiconsume/obtener?endpoint=${endpoint}`, '')
                .then(({ data }) => {
                    context.commit(SET_BOLETAS, data.data);
                    resolve(data)
                })
                .catch((error) => {
                    resolve(error)
                });
        });   
    },

    

    async [OBTENER_BOLETA](context, id){
        return new Promise(resolve => {
            ApiService.query(`apiconsume/edit/${id}?endpoint=api/Boleta/`)
                .then(({ data }) => {
                    context.commit(SET_BOLETA,data.data);
                    //console.log(this.instituciones)
                    resolve(data)
                })
                .catch((error) => {
                    
                    resolve(error)
                    //context.commit(SET_ERROR, response.data.errors);
                });
        });   
    },

    async [REGISTRAR_BOLETA](context, datos){
        return new Promise(resolve => {
            ApiService.post(`apiconsume/create?endpoint=api/Boleta`, datos)
                .then(({ data }) => {
                    context.commit(SET_BOLETA, data.data);
                    resolve(data)
                })
                .catch((error) => {
                    resolve(error)
                    //context.commit(SET_ERROR, response.data.errors);
                });
        });   
    },

    async [ACTUALIZAR_BOLETA](context, datos){
        //console.log("Aqui tambien")
        let id = datos.id;
        
        return new Promise(resolve => {
            ApiService.post(`apiconsume/update/${id}?endpoint=api/Boleta/`, datos)
                .then(({ data }) => {
                    context.commit(SET_BOLETA, data.data);
                    resolve(data)
                })
                .catch((error) => {
                    resolve(error)
                    //context.commit(SET_ERROR, response.data.errors);
                });
        });    
    },
    
}

const mutations = {
    [SET_BOLETAS](state, data) {
        state.boletas = data;
    },

    [SET_BOLETA](state, data) {
        state.boleta = data;
    }
}


export default {
    state,
    getters,
    actions,
    mutations
}